import { render, staticRenderFns } from "./ComprometimentoEnviarParaAnalise.vue?vue&type=template&id=635df6f3"
import script from "./ComprometimentoEnviarParaAnalise.vue?vue&type=script&lang=js"
export * from "./ComprometimentoEnviarParaAnalise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports